import { Component } from '@angular/core';
import { EntityWorkbenchComponent } from '../shared/entity-workbench.component';

@Component({
  standalone: true,
  imports: [EntityWorkbenchComponent],
  template: `
    <app-entity-workbench
      title="Membership Plans"
      description="Configure plan durations and pricing."
      collection="pricing"
      sort="-year"
      [fields]="fields"
    />
  `
})
export class MembershipPlansComponent {
  readonly fields = [
    { key: 'name', label: 'Plan Name' },
    { key: 'description', label: 'Description', type: 'textarea' as const },
    { key: 'periodmonths', label: 'Period (Months)' },
    { key: 'year', label: 'Year', type: 'number' as const },
    { key: 'price', label: 'Price' },
    { key: 'period_end_date', label: 'Period End Date', type: 'date' as const }
  ];
}
